Object.defineProperty(exports, "__esModule", {
  value: true
});
var inputTypes = {
  DATE: 'date',
  DATETIME: 'datetime-local',
  EMAIL: 'email',
  PASSWORD: 'password',
  TEL: 'tel',
  TEXT: 'text'
};

exports['default'] = inputTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/constants/inputTypes.js
// module id = 241
// module chunks = 923280921217